import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import type {StarterPrompt} from '../assistant';
import {useAuthStateManager} from './useAuthStateManager';
import RoleNames from '../lib/RoleNames';
import {assistantStarters} from '../lib/assistantStarters';

/**
 * Certavue's suggestions for an empty assistant conversation, from the page and
 * the user's roles. Passed to the assistant module as useStarterPrompts.
 */
export default function useAssistantStarterPrompts(): StarterPrompt[] {
    const {pathname} = useLocation();
    const {isInRole} = useAuthStateManager();
    const isAdministrator = isInRole(RoleNames.Administrator);
    const canManageDirectory = RoleNames.DirectoryEditors.some(isInRole);

    return useMemo(
        () => assistantStarters({pathname, isAdministrator, canManageDirectory}),
        [pathname, isAdministrator, canManageDirectory]
    );
}
